import React, { Component } from 'react'
import DashboardLayout from '../layouts/DashboardLayout'
import CheckLoginStatus from '../conditions/CheckLoginStatus'

export default class ArchivedPreTraining extends Component {
  constructor(props) {
    super(props)

    this.iframeRef = React.createRef()
    this.divRef = React.createRef()
    this.windowResized = this.windowResized.bind(this)

    window.onresize = this.windowResized
    window.onload = this.windowResized
  }

  windowResized() {
    if (this.divRef.current && this.iframeRef.current) {
      this.iframeRef.current.width = this.divRef.current.clientWidth
      this.iframeRef.current.height = this.divRef.current.clientHeight
    }
  }

  render() {
    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <DashboardLayout
          title="Archived Participants Pre-Training Materials"
          backHref="/resources/archived-resources"
          backText="Archived Resources"
          noPad
        >
          <div ref={this.divRef} style={{ width: '100%', height: '100%', zIndex: '-1', position: 'absolute', top: '0', left: '0' }}></div>
          <iframe
            title='drive'
            ref={this.iframeRef}
            src="https://drive.google.com/file/d/13J4R7Z7jOb1XWAXnc9DFDUXr733yeNT5/preview"
            style={{ border: 0 }}
          ></iframe>
        </DashboardLayout>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/ArchivedPreTraining.js